<template>
  <div :style="{ width: changestyle ? '11%' : '100%' }" class="goodDiv">
    <el-tree
      style="width: 100%;margin-right:10px;"
      class="filter-tree"
      highlight-current
      :data="treedata"
      :props="defaultProps"
      :default-expand-all="false"
      @node-click="NodeClick"
      ref="tree"
      node-key="id"
      :expand-on-click-node="false"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span v-show="isshowTitle == true">
          <el-button
            type="text"
            size="mini"
            style="margin-left:10px;"
            @click.stop="append(data)"
          >
            <!-- <i class="el-icon-plus"></i> -->
            {{ $t("GoodsList.changbtn[1]") }}
          </el-button>
          <el-button
            type="text"
            size="mini"
            v-show="node.data.IsFather == false"
            style="margin-left:5px;"
            @click.stop="edit(data)"
          >
            <!-- <i class="el-icon-edit"></i> -->
            {{ $t("GoodsList.changbtn[0]") }}
          </el-button>
        </span>
      </span>
    </el-tree>

    <el-dialog
      :title="shopclassTitle"
      :visible.sync="showShopclass"
      :modal="false"
      :before-close="shopclassClose"
      style="width: 1500px;margin: 0 auto;"
    >
      <el-form v-model="shopclassform">
        <el-form-item :label="$t('GoodsList.AddShopclass[0]')"
          ><el-input
            v-model="shopclassform.name"
            style="width:500px;"
          ></el-input
        ></el-form-item>
        <el-form-item
          :label="$t('GoodsList.AddShopclass[1]')"
          v-show="showRadio"
        >
          <el-radio
            @change="selectRadio"
            :disabled="Fdisable"
            v-model="radio"
            label="0"
            >{{ $t("GoodsList.AddShopclass[2]") }}</el-radio
          >
          <el-radio
            @change="selectRadio"
            :disabled="Sdisable"
            v-model="radio"
            label="1"
            >{{ $t("GoodsList.AddShopclass[3]") }}</el-radio
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitShopclassform()">{{
          $t("GoodsList.submitBtn")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import bus from "../bus";
import wmsApi from "@/request/wmsApi";
export default {
  name: "GoodClassTree",
  props: {
    isshowTitle: {
      required: false,
      default: false,
      type: Boolean
    },
    changestyle: {
      required: true,
      default: true,
      type: Boolean
    },
    currentPurchaseClass: {
      required: false,
      default: "",
      type: String
    },
    showMachine: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      treedata: [],
      defaultProps: {
        children: "childList",
        label: "name"
      },
      shopclassTitle: "",
      showShopclass: false,
      shopclassform: {},
      radio: "1",
      showRadio: true,
      Sdisable: false,
      Fdisable: false,
      appendclass: ""
    };
  },
  created() {
    this.GetGoodsTypeList();
  },
  methods: {
    async GetGoodsTypeList() {
      this.treedata = [];
      let goodListRes = await wmsApi.GetGoodsTypeList(
        this.currentPurchaseClass || ""
      );
      console.log("goodListRes: ", goodListRes);
      if (goodListRes.resultCode === 0) {
        if (this.showMachine) {
          this.treedata = goodListRes.data;
        } else {
          this.treedata = goodListRes.data.filter(
            item => item.name !== "Machine" && item.id !== 532
          );
        }
        this.$emit("plusTreeClass", goodListRes.data[0]);
      }
    },

    NodeClick(data) {
      console.log(data);
      this.$emit("selectTreeClass", data);
      this.$emit("plusTreeClass", data);
      // this.nodeID = data.id;
    },

    append(e) {
      // console.log('e1', e);
      this.shopclassTitle = this.$t("GoodsList.changtitle[2]");
      this.showShopclass = true;
      this.showRadio = true;
      this.appendclass = e;

      let typename = this.GetGoodsTypeName(this.treedata, e.id);
      let tmpArr = typename.split("/");
      console.log(tmpArr);
      if (tmpArr.length == 1) {
        this.Fdisable = true;
        this.radio = "1";
        this.shopclassform.id = 0;
        this.shopclassform.pid = e.id;
      } else if (tmpArr.length < 3) {
        this.Fdisable = false;
        //下级
        if (this.radio === "1") {
          this.shopclassform.id = 0;
          this.shopclassform.pid = e.id;
        }
        //同级
        if (this.radio === "0") {
          this.shopclassform.id = 0;
          this.shopclassform.pid = e.pid;
        }
      } else {
        this.Sdisable = true;
        this.radio = "0";
        if (this.radio === "0") {
          this.shopclassform.id = 0;
          this.shopclassform.pid = e.pid;
        }
      }
    },
    selectRadio(e) {
      if (this.radio === "1") {
        this.shopclassform.id = 0;
        this.shopclassform.pid = this.appendclass.id;
      }
      if (this.radio === "0") {
        this.shopclassform.id = 0;
        this.shopclassform.pid = this.appendclass.pid;
      }
    },
    edit(e) {
      console.log("e2", e);
      // console.log('e2',a)
      this.shopclassTitle = this.$t("GoodsList.changtitle[3]");
      this.showShopclass = true;
      this.shopclassform = e;
      this.showRadio = false;
    },
    async submitShopclassform() {
      console.log(this.shopclassform);
      let shopclassRes = await wmsApi.CreateOrEditGoodsType(
        this.token,
        this.shopclassform
      );
      console.log("shopclassRes", shopclassRes);
      if (shopclassRes.errMsg == "success!") {
        this.showShopclass = false;
        this.Sdisable = false;
        this.Fdisable = false;
        this.shopclassform = {};
        this.radio = "1";
        this.GetGoodsTypeList();
        this.$message({
          message: this.shopclassTitle + this.$t("GoodsList.msg[0]"),
          type: "success"
        });
      } else {
        this.shopclassform = {};
        this.$message({
          message: this.shopclassTitle + this.$t("GoodsList.msg[1]"),
          type: "warning"
        });
      }
    },
    shopclassClose() {
      this.showShopclass = false;
    },

    // 冒泡获取商品分类
    FindGoodsTypeByID(nowList, ID) {
      if (nowList == null || nowList.length == 0) return null;

      let typeModel = nowList.find(match => {
        return match.id == ID;
      });

      if (typeModel == null) {
        let result = null;
        for (let i = 0; i < nowList.length; i++) {
          result = this.FindGoodsTypeByID(nowList[i].childList, ID);
          if (result != null) break;
        }
        return result;
      } else return typeModel;
    },

    // 获取商品分类名称  1/2/3/4
    GetGoodsTypeName(typeList, TypeID) {
      let typeName = "";
      let HasFather = true;
      let tmpType = this.FindGoodsTypeByID(typeList, TypeID);
      console.log(tmpType);
      if (tmpType != null) {
        typeName += tmpType.name;
        while (HasFather) {
          tmpType = this.FindGoodsTypeByID(typeList, tmpType.pid);
          if (tmpType == null) HasFather = false;
          else typeName = tmpType.name + "/" + typeName;
        }
        return typeName;
      } else return typeName;
    }
  },
  computed: mapState({
    token: state => state.user.token
  }),
  watch: {
    currentPurchaseClass(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal) this.GetGoodsTypeList();
    }
  }
};
</script>

<style>
/* .goodDiv{
		height: 100%;
		overflow: hidden;
		overflow-y: scroll;
	} */
</style>



// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/GoodClassTree.vue